import httpClient from '../utils/httpClient';

const API = '/scholarship';

export const getScholarshipTypes = async () => httpClient.get(`${API}/types`);
export const createScholarshipType = async (data) => httpClient.post(`${API}/types`, data);
export const assignScholarship = async (data) => httpClient.post(API, data);
export const getAllScholarships = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.status) params.append('status', filters.status);
  if (filters.studentId) params.append('studentId', filters.studentId);
  const qs = params.toString();
  return httpClient.get(qs ? `${API}?${qs}` : API);
};
export const getScholarshipsByStudent = async (studentId) => httpClient.get(`${API}/student/${studentId}`);
export const getScholarshipSummary = async () => httpClient.get(`${API}/summary`);
export const updateScholarship = async (id, data) => httpClient.put(`${API}/${id}`, data);
export const revokeScholarship = async (id, data = {}) =>
  httpClient.put(`${API}/${id}/revoke`, data);
